import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"width":"75px"} }
const _hoisted_2 = { class: "overlay-wrapper card-rounded h-75px overflow-hidden border border-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark card-rounded bg-opacity-25" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
], -1)

import { inject, onMounted, Ref, ref, watch } from "vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import SupportService from "../services/SupportService";

export default /*#__PURE__*/_defineComponent({
  __name: 'CaseImages',
  props: {
    guid: {}
  },
  setup(__props: any) {

const props = __props;



const media = ref<any>({});
const contentUrlWithToken = ref("");
const getContentUrlWithToken = async () => {
  if (!props.guid) return;
  contentUrlWithToken.value = await SupportService.getImagesWithGuid(
    props.guid
  );
};

watch(() => props.guid, getContentUrlWithToken);

const fileShowRef = inject<Ref>(InjectKeys.FILE_SHOW_REF);

const handleMouseEnter = async (guid) => {
  if (!guid) return;
  media.value = { guid: guid, contentType: "image/jpeg" };
  fileShowRef?.value?.show(media.value);
};

onMounted(async () => {
  getContentUrlWithToken();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleMouseEnter(props.guid))),
      class: "d-block overlay mb-4",
      "data-fslightbox": "lightbox-hot-sales",
      href: "#"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (props.guid)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "w-100 h-100 overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded",
              style: _normalizeStyle(
              contentUrlWithToken.value !== ''
                ? `background-image: url(${contentUrlWithToken.value});`
                : ''
            )
            }, null, 4))
          : _createCommentVNode("", true)
      ]),
      _hoisted_3
    ])
  ]))
}
}

})